import makeStyles from '@mui/styles/makeStyles';
const dropdownSelectStyles = makeStyles(() => ({
    root: {},
    select: {},
    inputAdornment: {},
    inputRoot: {},
    errorText: {},
    outlined: {},
    selectError: {},
    label: {},
    disabled: {},
    item: {},
    itemSelected: {},
    itemLabel: {},
    itemDisabled: {},
    firstMenuItem: {},
    labelAsterixHidden: {},
    list: {},
    listPaper: {},
    helper: {},
    placeholder: {},
}), { name: 'DropdownSelect' });
export default dropdownSelectStyles;
//# sourceMappingURL=dropdownSelect.styles.js.map